// extracted by mini-css-extract-plugin
export var discard = "_4w-3";
export var muiTooltipTooltip = "_4w-5";
export var notificationBar = "_4w-2";
export var saveButtonHoverSlotWrapper = "_4w-4";
export var show = "_4w-1";
export var spacer = "_4w-0";